import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import ExpandableContent from 'Component/ExpandableContent';
import Html from 'Component/Html';
import { CategoryTreeType } from 'Type/Category.type';

import './YBCategoryExtraContent.style';

/** @namespace Elganso/Component/YBCategoryExtraContent/Component */
export class YBCategoryExtraContent extends PureComponent {
    static propTypes = {
        category: CategoryTreeType.isRequired,
        isCurrentCategoryLoaded: PropTypes.bool
    };

    static defaultProps = {
        isCurrentCategoryLoaded: true
    };

    renderExpandableHeading(extraTitle) {
        return (
            <h2>
                <Html content={ extraTitle } />
            </h2>
        );
    }

    renderCategoryExtraContent() {
        const {
            isCurrentCategoryLoaded
        } = this.props;

        if (!isCurrentCategoryLoaded) {
            return null;
        }

        const {
            category: {
                customizedAttributes: {
                    extraTitle,
                    extraContent
                } = {}
            }
        } = this.props;

        if (!extraTitle) {
            return null;
        }

        return (
            <ExpandableContent
              heading={ this.renderExpandableHeading(extraTitle) }
              isArrow
              key="YBCategoryExtraContent"
              mix={ { block: 'YBCategoryExtraContent', elem: 'ExpandableContent' } }
            >
                <div block="YBCategoryExtraContent" elem="Content"><Html content={ extraContent } /></div>
            </ExpandableContent>
        );
    }

    render() {
        return (
            <div block="YBCategoryExtraContent">
                { this.renderCategoryExtraContent() }
            </div>
        );
    }
}

export default YBCategoryExtraContent;
